import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import ModalRoot from '@commoncomponents/frontend-components/dist/components/ModalRoot';
import { breakpoints } from '@commoncomponents/frontend-components/dist/styled';
import { ducks, helpers, Utils } from '../../index';
import ContactWithSuperAdminModal from './ContactWithSuperAdminModal';
import CodeActivationSuccessModal from './CodeActivationSuccessModal';
import { AccountUpgradeType, AccountSettingsBaseRouteUrl } from './constants';
import UpgradeWithPaymentModal from './UpgradeWithPaymentModal';
import UpgradeWithCodeModal from './UpgradeWithCodeModal';
const UpgradeModal = ({ history, onModalClose, upgradeWithPaymentModalMessages, upgradeWithCodeModalMessages, contactWithSuperAdminModalMessages, currentUser, organizationActiveUsers, organizationPaymentUsers, isCodeActivated, ORGANIZATION_ACTIVE_USERS_ACTIONS: { REQUEST }, ORGANIZATION_PAYMENT_ACTIONS: { UNSELECT_ALL_USERS, ADD_PAYMENT_USERS }, ORGANIZATION_ACTIVATION_CODES_ACTIONS: { CLEAR_DATA }, PLAN_SUBSCRIPTIONS_ACTIONS: { GET_BILLINGS }, updateUsersList, }) => {
    const [upgradeType, setUpgradeType] = useState(AccountUpgradeType.PAYMENT);
    const isMobileView = useMediaQuery(breakpoints.md);
    const isSuperAdmin = currentUser && currentUser.role === 'SUPER_ADMIN';
    const currentUserEmail = currentUser.boxes && currentUser.boxes[0].identifier;
    const INVOICE_PATH = '/settings/account/organization/subscriptions/invoice';
    const USERS_PATH = `${AccountSettingsBaseRouteUrl}/plans-users`;
    const handleDetailsButtonClick = () => {
        ADD_PAYMENT_USERS(organizationPaymentUsers);
        if (helpers.isAccountApp()) {
            if (history.location.pathname !== INVOICE_PATH) {
                history.push(INVOICE_PATH);
            }
        }
        else {
            window.location.href = `${Utils.getUrlTo('accounts')}${INVOICE_PATH}`;
        }
        onModalClose();
    };
    const handleCancelButtonClick = () => {
        if (history.location.pathname !== INVOICE_PATH) {
            UNSELECT_ALL_USERS();
        }
        onModalClose();
    };
    const handleAddAnotherCodeButtonClick = () => {
        GET_BILLINGS();
        if (history.location.pathname === USERS_PATH) {
            updateUsersList();
        }
        CLEAR_DATA();
        UNSELECT_ALL_USERS();
        REQUEST();
        setUpgradeType(AccountUpgradeType.ACTIVATION_CODE);
    };
    const handleClose = () => {
        if (isCodeActivated)
            GET_BILLINGS();
        if (history.location.pathname === USERS_PATH) {
            updateUsersList();
        }
        CLEAR_DATA();
        UNSELECT_ALL_USERS();
        onModalClose();
    };
    useEffect(() => {
        REQUEST();
    }, []);
    return (React.createElement(ModalRoot, { open: true, customMaxWidth: isSuperAdmin ? 'min-content' : '612px', onClose: handleClose, autoFullScreenOnMobile: !isCodeActivated },
        React.createElement(React.Fragment, null,
            isSuperAdmin &&
                !isCodeActivated &&
                (upgradeType === AccountUpgradeType.PAYMENT ? (React.createElement(UpgradeWithPaymentModal, { translations: upgradeWithPaymentModalMessages, currentUserEmail: currentUserEmail, onClose: handleCancelButtonClick, onDetailsButtonClick: handleDetailsButtonClick, onHaveActivationCodeButtonClick: () => {
                        REQUEST();
                        setUpgradeType(AccountUpgradeType.ACTIVATION_CODE);
                    }, isMobileView: isMobileView })) : (React.createElement(UpgradeWithCodeModal, { translations: upgradeWithCodeModalMessages, currentUserEmail: currentUserEmail, onClose: onModalClose, backToUpgradeWithPaymentModal: () => {
                        setUpgradeType(AccountUpgradeType.PAYMENT);
                    }, isMobileView: isMobileView }))),
            !isSuperAdmin && (React.createElement(ContactWithSuperAdminModal, { organizationAccountsList: organizationActiveUsers, contactWithSuperAdminTranslations: contactWithSuperAdminModalMessages, onClick: () => onModalClose() })),
            isCodeActivated && (React.createElement(CodeActivationSuccessModal, { onClose: handleClose, onAddAnotherCodeButtonClick: handleAddAnotherCodeButtonClick, translations: upgradeWithCodeModalMessages.codeActivationSuccessModalMessages, currentUserEmail: currentUserEmail, isMobileView: isMobileView })))));
};
export const mapStateToProps = (state) => {
    return {
        currentUser: state.organizationUser.get('data'),
        organizationActiveUsers: state.organizationActiveUsers.get('data'),
        organizationPaymentUsers: state.organizationPayment.get('selectedUsers'),
        isCodeActivated: state.organizationActivationCodes.get('isCodeActivated'),
    };
};
export const mapDispatchToProps = (dispatch) => ({
    ORGANIZATION_ACTIVE_USERS_ACTIONS: bindActionCreators(ducks.ORGANIZATION_ACTIVE_USERS_ACTIONS, dispatch),
    ORGANIZATION_PAYMENT_ACTIONS: bindActionCreators(ducks.ORGANIZATION_PAYMENT_ACTIONS, dispatch),
    ORGANIZATION_ACTIVATION_CODES_ACTIONS: bindActionCreators(ducks.ORGANIZATION_ACTIVATION_CODES_ACTIONS, dispatch),
    PLAN_SUBSCRIPTIONS_ACTIONS: bindActionCreators(ducks.PLAN_SUBSCRIPTIONS_ACTIONS, dispatch),
});
export default connect(mapStateToProps, mapDispatchToProps)(UpgradeModal);
